import cart from './modules/cart';
import order from './modules/order';
import user from './modules/user';
import register from './modules/register';

export default {
  cart,
  order,
  register,
  user,
}
